// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAtGlA8ld_bZuymMbcqLfDK127-omRmtN0",
    authDomain: "kwexpreivreur.firebaseapp.com",
    projectId: "kwexpreivreur",
    storageBucket: "kwexpreivreur.appspot.com",
    messagingSenderId: "129151686727",
    appId: "1:129151686727:web:357ab1c037a23124d4f962",
    measurementId: "G-M4P07M13E0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default getFirestore(app);

